

!(function ($) {
    
    "use strict";

    var settings;
    var suppressDialog = false;

    $.fn.registerUnloadMessage = function (options) {

        settings = $.extend({
            // These are the defaults.
            message: "Achtung Sie haben Einstellungen geändert. Diese werden nicht gespeichert.",
            onSubmit: false,
            onLinkClicked: true,
            onF5Key: true
        }, options);


        window.onbeforeunload = unloadEvent;


        if (!settings.onF5Key) {
            $("document").bind("keypress", function(e) {
                if (e.keyCode === 116) {
                    suppressDialog = true;
                }
            });
        }

        var $body = $("body");

        if (!settings.onLinkClicked) {
            $body.on("click", "a", function() {
                suppressDialog = true;
            });
        }

        if (!settings.onSubmit) {

            $body.on("submit", "form", function (e) {
                suppressDialog = true;
            });

            $body.on("click", "input[type=submit]", function (e) {
                suppressDialog = true;
            });

        }

        
        return this;

    };

    function unloadEvent(e) {

        if (suppressDialog)
            return;

        if (!e)
            e = window.event;

        //e.cancelBubble is supported by IE - this will kill the bubbling process.
        e.cancelBubble = true;
        e.returnValue = settings.message;

        //e.stopPropagation works in Firefox.
        if (e.stopPropagation) {
            e.stopPropagation();
            e.preventDefault();
        }

        //return works for Chrome and Safari
        return settings.message;
    }


}(jQuery));